import type { FunctionComponent } from "react"

import classnames from "classnames"
import { NIL as NIL_UUID } from "uuid"

import { Tag } from "@jobteaser/ui-kit/components/Tag/Tag"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { isLinkActive } from "@/modules/headerFooterFO/Header/helpers/isLinkActive"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { useHref } from "@/modules/routing/hooks/useHref"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import navStyles from "@/modules/headerFooterFO/Header/Nav/Nav.module.css"

export const CareerCenter: FunctionComponent = () => {
  const { t } = useTranslation(["module_header_fo"])
  const href = useHref()
  const locale = useLocale()
  const { dataCurrentUser } = useCurrentUserFetch()

  const { dataCareerCenter } = useCareerCenterFetch()
  const isWwwCC = dataCareerCenter?.id === NIL_UUID

  if (!dataCurrentUser?.isLogged || isWwwCC) {
    return null
  }

  const isAssociatedCareerCenter = !!dataCareerCenter?.mainCareerCenterConf

  return (
    <>
      {isAssociatedCareerCenter && !!dataCareerCenter.mainCareerCenterConf?.hasMainCareerCenterArticles && (
        <li className={classnames(navStyles["app-Nav__item"], navStyles["app-Nav__item--handbook"])}>
          <a
            className={classnames(navStyles["app-Nav__link"], {
              [navStyles["app-Nav__link--active"]]: isLinkActive(
                href,
                `/${locale}/handbook?school_id=${dataCareerCenter.mainCareerCenterIdOld}`
              ),
            })}
            href={`/${locale}/handbook?school_id=${dataCareerCenter.mainCareerCenterIdOld}`}
          >
            {dataCareerCenter?.mainCareerCenterConf?.mainCareerCenterCustomResourceLocale}
          </a>
        </li>
      )}

      {!!dataCareerCenter?.careerCenterConf?.modules.hasArticles && !isWwwCC && (
        <li className={classnames(navStyles["app-Nav__item"], navStyles["app-Nav__item--ressources"])}>
          <a
            className={classnames(navStyles["app-Nav__link"], {
              [navStyles["app-Nav__link--active"]]: isLinkActive(
                href,
                `/${locale}/handbook?school_id=${dataCareerCenter.idOld}`
              ),
            })}
            href={`/${locale}/handbook?school_id=${dataCareerCenter.idOld}`}
          >
            {dataCareerCenter?.careerCenterConf?.customResourceLocale || t("module_header_fo.nav_resources")}
          </a>
        </li>
      )}

      {/* Appointments */}
      {!!dataCareerCenter?.careerCenterConf?.modules.hasAppointments &&
        !!dataCareerCenter?.careerCenterConf.modules.hasAppointmentsLaunchedInFo && (
          <li className={classnames(navStyles["app-Nav__item"], navStyles["app-Nav__item--appointment"])}>
            <a
              className={classnames(navStyles["app-Nav__link"], {
                [navStyles["app-Nav__link--active"]]: isLinkActive(href, `/${locale}/v2/appointments`),
              })}
              href={`/${locale}/v2/appointments`}
            >
              {t("module_header_fo.nav_appointments")}
            </a>
          </li>
        )}

      {/* Career explorer */}
      {!!dataCareerCenter?.careerCenterConf?.modules.hasLearningPlatformAccess && (
        <li className={classnames(navStyles["app-Nav__item"], navStyles["app-Nav__item--careerExplorer"])}>
          <a
            className={classnames(navStyles["app-Nav__link"], {
              [navStyles["app-Nav__link--active"]]: isLinkActive(href, `/${locale}/career-explorer`),
            })}
            href={`/${locale}/career-explorer/dashboard`}
          >
            Career Explorer
            <Tag size="small" color="purple" className={navStyles["app-Nav__newTag"]}>
              New
            </Tag>
          </a>
        </li>
      )}
    </>
  )
}
